import { Stack, Typography } from "@mui/material";
import { CoreTextField } from "@verity/components/core";
import React, { useState } from "react";
import i18n from "../../../../../../../i18n";
import { getPlatformLabel } from "../../../../utils";
import { ProctoringOptionsType, SessionType } from "../../../types";
import { CameraIcon, ClockIcon, PersonIcon } from "../assets/sessionInfoAssets";
import styles from "./SessionInfo.module.css";

function formatDuration(start: Date, end: Date): string {
	const ms = end.getTime() - start.getTime();
	const totalMinutes = Math.floor(ms / 1000 / 60);
	const hours = Math.floor(totalMinutes / 60);
	const minutes = totalMinutes % 60;

	return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}

type DataRowProps = {
	icon: React.ReactNode;
	title: string;
	value: string | React.ReactNode;
};

function DataRow({ icon, title, value }: DataRowProps) {
	return (
		<Stack direction="row" justifyContent="space-between" alignItems="center">
			<Stack direction="row" spacing="8px" alignItems="center">
				{icon}
				<Typography className={styles.text}>{title}</Typography>
			</Stack>
			{typeof value === "string" ? <Typography className={styles.text}>{value}</Typography> : value}
		</Stack>
	);
}

type SessionInfoTabProps = {
	proctoringOptions: ProctoringOptionsType;
	sessionInfo: SessionType;
};

export default function SessionInfoTab({ proctoringOptions, sessionInfo }: SessionInfoTabProps) {
	const duration = formatDuration(new Date(sessionInfo.startTime), new Date(sessionInfo.endTime));

	const [notes, setNotes] = useState("");

	return (
		<Stack spacing="24px">
			<Stack direction="row" spacing="24px">
				<div className={styles.dataBox}>
					<Typography className={styles.title}>
						{i18n.t("candidate.instructorInterviewPage.inProgress.tabs.info.title")}
					</Typography>
					<Stack spacing="25px">
						<DataRow
							icon={<PersonIcon />}
							title={i18n.t("candidate.instructorInterviewPage.inProgress.tabs.info.candidateName")}
							value={proctoringOptions.candidateInterviewOptions.candidateName}
						/>
						<DataRow
							icon={<ClockIcon />}
							title={i18n.t("candidate.instructorInterviewPage.inProgress.tabs.info.duration")}
							value={duration}
						/>
						<DataRow
							icon={<CameraIcon />}
							title={i18n.t("candidate.instructorInterviewPage.inProgress.tabs.info.videoPlatform")}
							value={getPlatformLabel(proctoringOptions.candidateInterviewOptions.videoPlatform)}
						/>
					</Stack>
				</div>

				<div className={styles.dataBox}>
					<Typography className={styles.title}>
						{i18n.t("candidate.instructorInterviewPage.inProgress.tabs.info.notes.title")}
					</Typography>
					<CoreTextField
						className={styles.notes}
						multiline
						fullWidth
						placeholder={i18n.t("candidate.instructorInterviewPage.inProgress.tabs.info.notes.placeholder")}
						value={notes}
						onChange={(e) => setNotes(e.target.value)}
					/>
				</div>
			</Stack>
		</Stack>
	);
}
